export interface CheckPasswordRenewalStatusRequestDto {
  username: string;
  password: string;
}

export interface CheckPasswordRenewalStatusResponseDto {
  required: boolean;
  username: string;
  password: string;
}

export enum VerificationTypes {
  Sms = 1,
  Email = 2,
}

export interface SendPasswordRenewalOtpRequestDto {
  username: string;
  verificationType: VerificationTypes;
}

export interface SendPasswordRenewalOtpResponseDto {
  verificationSeconds: number;
}

export interface ChangePasswordRenewalRequestDto {
  username: string;
  oldPassword: string;
  newPassword: string;
  newPasswordRepeat: string;
  otpCode: string;
  clientId: string | null;
}

export interface PasswordRenewalChangeResponseDto {
  sessionKey: string;
  redirectUrl: string | null;
  user: { email: string; username: string; userRoles: number[] };
}

export interface PasswordRenewalValidateRequestDto {
  username: string;
  oldPassword: string;
  newPassword: string;
}

export interface PasswordRenewalValidateResponseDto {
  oldPasswordValid: boolean;
  newPasswordSameAsOld: boolean;
  newPasswordInLastTwo: boolean;
}
